import React from 'react';
import { BrokerRateModel, CarClassModel, CarModelModel, DeskModel, ProductModel } from '../api/core/core.types';
import { ListLinkElement } from '../modules/core/types/rates.types';
import { SupplierBrokerModel } from '../api/admin/admin.types';

export const generateCarElementLink = (code: string, carModels: CarModelModel[]) => {
  const modelEl = carModels.find((c) => c.acrissCode === code);
  if (modelEl) {
    return `/setup/carmodels/${modelEl.id}/view`;
  }
  return '';
};

export const generateCarElementLinkForCarClass = (code: string, carModels: CarClassModel[]) => {
  const modelEl = carModels.find((c) => c.acrissCode === code);
  if (modelEl) {
    return `/setup/carmodels/${modelEl.id}/view`;
  }
  return '';
};

export const getLocationsList =
  (
    selectedDesks: { deskCode: string }[],
    desks: DeskModel[],
    includeDeskWithoutItem: boolean,
    history: any
  ) => {
    let deskList;
    const deskItems: ListLinkElement[] = [];

    if (selectedDesks.length === 0) {
      deskList = 'All desks';
    } else {
      selectedDesks.forEach((i) => {
        const desk = desks.find((d) => d.code === i.deskCode);
        const deskItem = {
          linkAddress: `/setup/desks/${i.deskCode}/view`,
          label: ''
        };
        if (desk) {
          deskItem.label = desk.name;
          deskItems.push(deskItem);
        } else if (!desk && includeDeskWithoutItem) {
          deskItem.label = i.deskCode;
          deskItems.push(deskItem);
        }
      });

      // eslint-disable-next-line no-nested-ternary
      deskItems.sort((a, b) => ((a.label < b.label) ? -1 : (a.label > b.label) ? 1 : 0));
      deskList = (
        <ul className="details-list">
          {deskItems.map((desk) => (
            <li
              key={desk.label}
              className="list-link-item"
              onClick={() => history.push(desk.linkAddress)}
            >
              {
                desk.label
              }
            </li>
          ))}
        </ul>
      );
    }
    return deskList;
  };

export const getCarClassesList =
  (selectedCarClasses: { acrissCode: string }[],
   carModels: CarClassModel[],
   allSelectedLabel: string,
   history: any
  ) => {
    let carClassList;

    if (selectedCarClasses.length === 0) {
      carClassList = allSelectedLabel;
    } else {
      // eslint-disable-next-line no-nested-ternary
      selectedCarClasses.sort((a, b) => ((a < b) ? -1 : (a > b) ? 1 : 0));
      carClassList = (
        <ul className="details-list-with-columns">
          {selectedCarClasses.map((carClass: { acrissCode: string }) => (
            <li
              key={carClass.acrissCode}
            >
              {carClass.acrissCode}
            </li>
          ))}
        </ul>
      );
    }
    return carClassList;
  };

export const getBrokers =
  (
    selectedBrokers: { id: number }[],
    brokers: SupplierBrokerModel[],
    allSelectedLabel: string
  ) => {
    let brokerList;
    if (selectedBrokers.length === 0) {
      brokerList = allSelectedLabel;
    } else {
      brokerList = (
        <ul className="details-list">
          {selectedBrokers.map((broker: { id: number }) => {
            const fullBroker = brokers.find((d) => d.id === broker.id);
            return (
              <li key={broker.id}>
                {
                  fullBroker && fullBroker.name || broker.id
                }
              </li>
            );
          })}
        </ul>
      );
    }
    return brokerList;
  };

export const getProducts =
  (
    selectedProducts: { code: string }[],
    products: ProductModel[],
    allSelectedLabel: string
  ) => {
    let brokerList;
    if (selectedProducts.length === 0) {
      brokerList = allSelectedLabel;
    } else {
      brokerList = (
        <ul className="details-list">
          {selectedProducts.map((product: { code: string }) => {
            const fullProduct = products.find((d) => d.code === product.code);
            return (
              <li key={product.code}>
                {
                  fullProduct?.name || product.code
                }
              </li>
            );
          })}
        </ul>
      );
    }
    return brokerList;
  };

export const getBrokerRates =
  (
    selectedBrokerRates: { code: string } [],
    brokerRates: BrokerRateModel[],
    allSelectedLabel: string,
    history: any
  ) => {
    let brokerRateList;
    if (selectedBrokerRates.length === 0) {
      brokerRateList = allSelectedLabel;
    } else {
      brokerRateList = (
        <ul className="details-list">
          {selectedBrokerRates.map((selectedBrokerRate: { code: string }) => {
            const fullBrokerRate = brokerRates.find((d) => d.code === selectedBrokerRate.code);
            return (
              <li
                key={selectedBrokerRate.code}
                className="list-link-item"
                onClick={() => fullBrokerRate ? history.push(`/setup/brokerRates/${fullBrokerRate.code}/view`) : null}
              >
                {
                  fullBrokerRate && fullBrokerRate.name || selectedBrokerRate.code
                }
              </li>
            );
          })}
        </ul>
      );
    }
    return brokerRateList;
  };

